export default {
    403: 'Nie masz uprawnień do wykonania tej operacji.',
    413: 'Plik przekracza limit wielkości pliku serwera. Skontaktuj się z administratorem.',
    422: 'Dane, które wprowadziłeś są nieprawidłowe. Sprawdź je i spróbuj ponownie.',
    429: 'Działasz za szybko! Przekroczyłeś dozwoloną liczbę akcji w minutę. Spróbuj ponownie później.',
    503: 'Usługa jest tymczasowo niedostępna, spróbuj ponownie później lub skontaktuj się z administratorem.',
    login: 'Wystąpił błąd podczas logowania. Spróbuj ponownie później lub skontaktuj się z administratorem.',
    undefined: 'Wystąpił niezidentyfikowany błąd. Spróbuj ponownie później.'
}
